import type { CalculatorMeta } from '../../types/calculator';

export const REAL_PURCHASING_POWER_CALC: CalculatorMeta = {
  route: '/real-purchasing-power-calculator',
  component: () => import('../../routes/RealPurchasingPower.svelte'),
  card: {
    id: 'real-purchasing-power',
    title: 'Real Purchasing Power Calculator',
    description: 'Calculate inflation-adjusted future values and see how inflation erodes your purchasing power over time.',
    icon: 'savings',
    iconBgClass: 'bg-blue-100 dark:bg-blue-900/30',
    iconTextClass: 'text-blue-600 dark:text-blue-300',
    href: '/real-purchasing-power-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Real Purchasing Power Calculator - Inflation-Adjusted Returns',
    description: 'Free real purchasing power calculator that shows inflation-adjusted future values. See how much of your investment gains are real wealth gains vs. just keeping up with inflation.',
    keywords: [
      'real purchasing power calculator',
      'inflation adjusted returns',
      'real vs nominal returns',
      'purchasing power calculator',
      'inflation calculator',
      'real value of money',
      'inflation adjusted investment returns',
    ],
  },
};
